import React, { Component } from 'react';
import data from '../data/data.json';

class Screen1 extends Component {
    item = () => {
        const items = [];
        
        // get categories to filter from query parameters
        const params = new URLSearchParams(this.props.location.search);
        let categories = params.get('categories');
        if (categories) { 
            categories = categories.split(',');
        }

        Object.keys(data.blogPosts).map((key, index) => {
            const item = data.blogPosts[key];
            // check if post is in specified category list
            const categories_length = categories? categories.length: 0
            let foundCategoryFlag = false;
            for (let i=0; i < categories_length; i++) {
                if (item.categories.indexOf(categories[i]) != -1) {
                    foundCategoryFlag = true;
                    break;            
                }
            }
            // do not display if items is not in the specified category list
            if (categories && !foundCategoryFlag) return;

            items.push(
                <div className="col-md-4 mb-3" key={`${key}`}>
                    <div className="card blog-post-card">
                        <img
                            className="card-img-top"
                            src={item.image}
                            alt="image"
                        />
                        <div className="card-body">
                            <h5 className="card-title">
                                <a
                                    className="theme-link"
                                    href={`/posts/${item.fileName}`}
                                >
                                    {item.title}
                                </a>
                            </h5>
                            <p className="card-text">{item.summary}</p>
                            <p className="mb-0">
                                <a className="more-link" href={`/posts/${item.fileName}`}>
                                    Read more →
                                </a>
                            </p>
                        </div>
                        <div className="card-footer">
                            <small className="text-muted">
                                Published {item.date}
                            </small>
                        </div>
                    </div>
                </div>
            );
        });

        return items;
    };

    render() {
        return (
            <div>
                <section className="cta-section theme-bg-light py-5">
                    <div className="container text-center">
                        <h2 className="heading">
                            Software, Electronics and other interesting stuff
                        </h2>
                        <div className="intro">Welcome to my notes</div>
                    </div>
                </section>

                <section className="blog-list px-3 py-5 p-md-5">
                    <div className="container">
                        <div className="row">{this.item()}</div>

                        {/*
                        <nav className="blog-nav nav nav-justified my-5">
                            <a
                                className="nav-link-prev nav-item nav-link d-none rounded-left"
                                href="#"
                            >
                                Previous
                                <svg
                                    className="svg-inline--fa fa-long-arrow-alt-left fa-w-14 arrow-prev"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="long-arrow-alt-left"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    data-fa-i2svg=""
                                >
                                    <path
                                        fill="currentColor"
                                        d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                                    ></path>
                                </svg>
                            </a>
                            <a
                                className="nav-link-next nav-item nav-link rounded"
                                href="#"
                            >
                                Next
                                <svg
                                    className="svg-inline--fa fa-long-arrow-alt-right fa-w-14 arrow-next"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="long-arrow-alt-right"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                    data-fa-i2svg=""
                                >
                                    <path
                                        fill="currentColor"
                                        d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                                    ></path>
                                </svg>
                            </a>
                        </nav>
                        */}
                    </div>
                </section>
            </div>
        );
    }
}

export default Screen1;
